// extracted by mini-css-extract-plugin
export default {"main":"pageNotFound_main__vyEqF","image":"pageNotFound_image__vhQXn"};